import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import { useSelector } from 'react-redux';

const GlobalLoader = () => {
  const loadingCount = useSelector((state) => state.loading.count);
  const loadingMessage = useSelector((state) => state.loading.message);
  const isLoading = loadingCount > 0;

  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
      open={isLoading}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress color="inherit" size={60} thickness={4} />
        <Typography variant="h6" sx={{ fontWeight: 600, letterSpacing: 1 }}>
          {loadingMessage}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default GlobalLoader;
